import { WorkerAction, WorkerFnParams } from '../wasm-git.worker.model';
import { FSAction } from './actions.enum';
import { FSWriteFileActionFn } from './fs-write-file';

export interface FSWriteJSONAction extends WorkerAction {
  type: FSAction.WriteJSON;
  params: {
    path: string;
    propertyPath?: string[];
    content?: unknown;
    skipSync?: boolean;
  };
}

export async function FSWriteJSONActionFn(params: WorkerFnParams<FSWriteJSONAction>): Promise<void> {
  const { params: actionParams, ...workerFnParams } = params;
  await FSWriteFileActionFn({
    ...workerFnParams,
    params: {
      ...actionParams,
      content: stringifyJSON(actionParams.content || ''),
    },
  });
}

/**
 * Define a common method that all feature services will use
 * to stringify the models before writing to git.
 */
export function stringifyJSON(value: unknown) {
  return JSON.stringify(value, null, 2);
}
